import { DateTime } from 'luxon';
import type { Me } from '@whizz/react-identity/dist/@types/types/Me';
import type { DateRangeType } from '../forms/types';
import type { DateRangeOptionsType } from '../pages/types';
import type Teacher from '@whizz/api-client/dist/@types/model/Teacher';
import type { EndDateType, StartDateType } from '../util/types';
import { LAST_WEEKS } from '../util/vars';

export const getDatesParams = (
  selectedValue: DateRangeOptionsType,
  customDateValue: DateRangeType,
  ayStartDate: DateTime | null,
  me:  Me | null | undefined,
): { startDateParam: StartDateType, endDateParam: EndDateType } => {
  const lastMonday = me ? (me as Teacher).startOfWeek() : null;

  // If ayStartDate is null, return September
  const thisYear = DateTime.now().year;
  const thisMonth = DateTime.now().month;
  const acYear = (thisMonth > 8) ? thisYear : thisYear - 1;

  switch (selectedValue) {
    case 'last_x':
      return {
        startDateParam: DateTime.now().minus({ weeks: LAST_WEEKS }),
        endDateParam: null,
      };
    case 'last_week':
      return {
        startDateParam: DateTime.now().startOf('day').minus({ weeks: 1 }).plus({ days: 1 }), // Add 1 day to include today
        endDateParam: null,
      };
    case 'since_x':
      return {
        startDateParam: lastMonday ? lastMonday : DateTime.now().startOf('week'),
        endDateParam: null,
      };
    case 'current_acYear':
      return {
        startDateParam: ayStartDate ? ayStartDate : DateTime.local(acYear, 9, 1),
        endDateParam: null,
      };
    case 'cay':
      return {
        startDateParam: 'CAY',
        endDateParam: null,
      };
    case 'since_last':
      return {
        startDateParam: 'last-assessment',
        endDateParam: null,
      };
    case 'full':
      return {
        startDateParam: 'first-assessment',
        endDateParam: null,
      };
    case 'custom':
      return {
        startDateParam: (customDateValue.startDate)
          ? DateTime.fromJSDate(customDateValue.startDate).startOf('day')
          : 'first-assessment',
        endDateParam: (customDateValue.endDate)
          ? DateTime.fromJSDate(customDateValue.endDate).endOf('day')
          : null,
      };
  }
};
